"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var serializedCellProperties = [
    'id', 'type',
    'size', 'angle', 'isExpanded', 'position', 'iri', 'group',
    'typeId', 'source', 'target', 'vertices',
];
function normalizeImportedCell(cell) {
    var newCell = lodash_1.pick(cell, serializedCellProperties);
    if (newCell.type === 'Ontodia.Element') {
        newCell.type = 'element';
    }
    if (!newCell.iri) {
        newCell.iri = newCell.id;
    }
    return newCell;
}
exports.normalizeImportedCell = normalizeImportedCell;
function exportLayoutData(elements, links) {
    var elementData = elements.map(function (element) { return ({
        type: 'element',
        id: element.id,
        iri: element.iri,
        position: element.position,
        size: element.size,
        isExpanded: element.isExpanded,
        group: element.group,
    }); });
    var linkData = links.map(function (link) { return ({
        type: 'link',
        id: link.id,
        typeId: link.typeId,
        source: { id: link.sourceId },
        target: { id: link.targetId },
        vertices: link.vertices.slice(),
    }); });
    var cells = elementData.concat(linkData);
    return { cells: cells };
}
exports.exportLayoutData = exportLayoutData;
